//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GenericResponse, ResponseDueDate } from "../../types/common";
import { getDueDateApi } from "../../methods/Methods";
import { AxiosError } from "axios";



//-------------------------------------------------------------------------------------------------- Interfaces
interface FillDueDateSliceInterface {
    clientId: string;
};

interface DueDateSliceInterface {
    clientId: string;
    data: ResponseDueDate | null;
    status: number;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
let statusOfRequest = 0;

const dueDateSliceInitialState = {
    clientId: "",
    data: null,
    status: 0
} as DueDateSliceInterface;



//-------------------------------------------------------------------------------------------------- Thunks
const fillDueDateSlice = createAsyncThunk(
    "thunk/dueDate", async (object: FillDueDateSliceInterface): Promise<DueDateSliceInterface> => {
        let data: DueDateSliceInterface = {
            clientId: object.clientId,
            data: null,
            status: 0
        };
        
        await getDueDateApi(object.clientId)
            .then((response: GenericResponse<ResponseDueDate>) => {
                if( response.data && response.data[0] ){
                    statusOfRequest = 1;
                    data.data = response.data[0];
                }
                else{
                    statusOfRequest = 2;
                }
            }).catch((error: AxiosError<any>) => {
                statusOfRequest = 2;
            });

        return data;
    }
);



//-------------------------------------------------------------------------------------------------- Slice
const dueDateSlice = createSlice({
    name: "dueDate",
    initialState: dueDateSliceInitialState,
    reducers: {
        setDueDate: (state, action: PayloadAction<DueDateSliceInterface>) => {
            state.data = action.payload.data;
        },
        clearDueDate: (state) => {
            statusOfRequest = 0;
            state.data = dueDateSliceInitialState.data;
            state.status = dueDateSliceInitialState.status;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fillDueDateSlice.fulfilled, (
            state, action: PayloadAction<DueDateSliceInterface>
        ) => {
            state.data = action.payload.data;
            state.clientId = action.payload.clientId;
            state.status = statusOfRequest;
        });
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export {fillDueDateSlice};
export const {setDueDate, clearDueDate} = dueDateSlice.actions;
export const getDueDate = (state: any) => state.dueDate as DueDateSliceInterface;
export default dueDateSlice.reducer;
